
import Header from './components/Header';
import HeroBanner from './components/HeroBanner';
import ImpactSection from './components/ImpactSection';
import AppRecommendSection from './components/AppRecommendSection';
import GirlsSection from './components/GirlsSection';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroBanner />
        <ImpactSection />
        <AppRecommendSection />
        <GirlsSection />
      </main>
      <Footer />
    </div>
  );
}
